import { UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import { ICpdInfoCardItem } from 'shared/containers/CpdUnderDescriptionContainer/constants';

import styles from './styles.css';

interface ICpdInfoCardProps extends ICpdInfoCardItem {
  onClick: () => void;
}

export const CpdInfoCard: React.FC<ICpdInfoCardProps> = ({
  imageUrl,
  imageStyle,
  title,
  backgroundColor,
  onClick,
  className,
  isFirst = false,
}) => {
  return (
    <div
      className={className ? `${styles.card} ${className}` : styles.card}
      style={{ backgroundColor }}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <div className={styles['title']}>
        <UIHeading3 color="text-primary-default">{title}</UIHeading3>
      </div>
      <img
        src={imageUrl}
        alt={title}
        className={isFirst ? styles['image-first'] : styles['image']}
        style={imageStyle}
      />
    </div>
  );
};
